import { motion } from "framer-motion";
import { ArrowRight, PhoneCall } from "lucide-react";
import { Reveal } from "@/components/Reveal";

export const FinalCTA = ({ onStart, onCallback }) => (
  <section data-testid="final-cta" className="bg-navy py-20 sm:py-28">
    <div className="mx-auto max-w-4xl px-5 text-center sm:px-8">
      <Reveal>
        <p className="text-xs font-bold uppercase tracking-[0.25em] text-cognac-light sm:text-sm">
          CozyHome
        </p>
        <h2 className="mt-5 font-display text-4xl font-medium tracking-tight text-white sm:text-6xl">
          Prêt à donner vie à <span className="italic text-wood">votre projet ?</span>
        </h2>
        <p className="mx-auto mt-6 max-w-xl text-sm leading-relaxed text-white/65 sm:text-base">
          Parlez-nous de votre projet en quelques minutes. CozyHome vous aide à
          définir les prochaines étapes.
        </p>
        <div className="mt-10 flex flex-wrap items-center justify-center gap-4">
          <motion.button
            data-testid="final-cta-estimate"
            onClick={onStart}
            whileHover={{ scale: 1.04 }}
            whileTap={{ scale: 0.98 }}
            className="group flex items-center gap-2.5 rounded-full bg-cream px-9 py-4 text-sm font-bold text-navy transition-colors duration-300 hover:bg-cognac hover:text-white"
          >
            Parler de mon projet
            <ArrowRight className="h-4 w-4 transition-transform duration-300 group-hover:translate-x-1" />
          </motion.button>
          <button
            data-testid="final-cta-callback"
            onClick={onCallback}
            className="flex items-center gap-2.5 rounded-full border border-white/25 px-8 py-4 text-sm font-bold text-white transition-colors duration-300 hover:border-cognac-light hover:text-cognac-light"
          >
            <PhoneCall className="h-4 w-4" />
            Être rappelé
          </button>
        </div>
      </Reveal>
    </div>
  </section>
);
